module.exports = __webpack_public_path__ + "static/media/forth.d95ab33d.png";